// extracted by mini-css-extract-plugin
module.exports = {"main":"AccountPageLayout_main__LWPgN","title":"AccountPageLayout_title__kmggA"};